// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9694b23e","977":"0296d865"}[chunkId] + ".chunk.js";
};